/* VIORA · Enjuague morado blanqueador — comportamiento de la tienda.
   Rutas relativas: la página puede servirse en la raíz o bajo un prefijo. */

/* ── Revelado al entrar en pantalla ─────────────────────── */
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var sibs = Array.prototype.slice.call(e.target.parentNode.children).filter(function (n) {
        return n.classList && n.classList.contains('reveal');
      });
      e.target.style.transitionDelay = Math.min(sibs.indexOf(e.target), 5) * 70 + 'ms';
      e.target.classList.add('in'); io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
  els.forEach(function (el) { io.observe(el); });
})();

/* ── Nav con borde + barra de compra ────────────────────── */
(function () {
  var nav = document.getElementById('nav');
  if (!nav) return;
  var bar = document.getElementById('buybar');
  var hero = document.querySelector('.hero');
  var offer = document.getElementById('comprar');
  function onScroll() {
    var y = window.scrollY;
    nav.classList.toggle('stuck', y > 12);
    if (!bar) return;
    var heroOut = y > (hero ? hero.offsetHeight * .7 : 500);
    var offerTop = offer ? offer.getBoundingClientRect().top : 9999;
    var overOffer = offerTop < window.innerHeight * .9 && offerTop > -(offer ? offer.offsetHeight : 0);
    bar.classList.toggle('show', heroOut && !overOffer);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ── Contador de stock (baja despacio, nunca por debajo de 11) ── */
(function () {
  var el = document.getElementById('stock');
  if (!el) return;
  var KEY = 'viora_stock';
  var n = parseInt(sessionStorage.getItem(KEY) || '0', 10);
  if (!n) { n = 34 + Math.floor(Math.random() * 9); sessionStorage.setItem(KEY, String(n)); }
  el.textContent = n;
  setTimeout(function loop() {
    if (n > 11) { n -= 1; try { sessionStorage.setItem(KEY, String(n)); } catch (e) {} el.textContent = n; }
    setTimeout(loop, 45000 + Math.random() * 55000);
  }, 40000 + Math.random() * 40000);
})();

/* ── Año del footer ─────────────────────────────────────── */
(function () { var y = document.getElementById('year'); if (y) y.textContent = new Date().getFullYear(); })();

/* ── Before / After slider ──────────────────────────────── */
(function () {
  var frame = document.getElementById('baFrame');
  if (!frame) return;
  var after = document.getElementById('baAfter');
  var handle = document.getElementById('baHandle');
  function setSplit(pct) {
    pct = Math.max(4, Math.min(96, pct));
    after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
    handle.style.left = pct + '%';
  }
  function fromEvent(clientX) {
    var r = frame.getBoundingClientRect();
    setSplit(((clientX - r.left) / r.width) * 100);
  }
  var dragging = false;
  function down(e) { dragging = true; fromEvent((e.touches ? e.touches[0] : e).clientX); e.preventDefault(); }
  function move(e) { if (!dragging) return; fromEvent((e.touches ? e.touches[0] : e).clientX); }
  function up() { dragging = false; }
  frame.addEventListener('mousedown', down);
  frame.addEventListener('touchstart', down, { passive: false });
  window.addEventListener('mousemove', move);
  window.addEventListener('touchmove', move, { passive: false });
  window.addEventListener('mouseup', up);
  window.addEventListener('touchend', up);
  setSplit(50);
  // Pequeño "teaser" al entrar en pantalla: mueve la barra sola una vez.
  var teased = false;
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      if (!en.isIntersecting || teased) return; teased = true;
      var t = 0; var iv = setInterval(function () {
        t += 1; var p = 50 + Math.sin(t / 6) * 22; setSplit(p);
        if (t > 30) { clearInterval(iv); setSplit(50); }
      }, 28);
    });
  }, { threshold: .4 });
  io.observe(frame);
})();

/* ── Home: los CTA "Comprar/Elegir pack" llevan a la ficha de producto ─── */
(function () {
  var target = (window.VIORA_PRODUCT_URL || '/products/viora-enjuague-morado');
  var isPDP = !!document.querySelector('[data-pdp-form]');
  if (isPDP) return; // en la ficha los data-buy ya se convirtieron en anclas
  document.querySelectorAll('[data-buy]').forEach(function (b) {
    b.addEventListener('click', function (ev) { ev.preventDefault(); window.location.href = target; });
  });
})();

/* ── Ficha de producto: packs (variantes) + añadir al carrito ─────────── */
(function () {
  var form = document.querySelector('[data-pdp-form]');
  if (!form) return;
  var addbarPrice = document.querySelector('[data-addbar-price]');
  var cards = form.querySelectorAll('.ppack');

  function setPrice(str) {
    document.querySelectorAll('[data-pdp-price]').forEach(function (e) { e.textContent = str; });
    if (addbarPrice && str) addbarPrice.textContent = str;
  }
  cards.forEach(function (c) {
    c.addEventListener('click', function () {
      cards.forEach(function (x) { x.classList.remove('sel'); var r = x.querySelector('input'); if (r) r.checked = false; });
      c.classList.add('sel');
      var r = c.querySelector('input'); if (r) r.checked = true;
      if (c.dataset.priceStr) setPrice(c.dataset.priceStr);
    });
  });
  var pre = form.querySelector('.ppack.sel');
  if (pre && pre.dataset.priceStr) setPrice(pre.dataset.priceStr);

  function addToCart() {
    var checked = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
    if (!checked || !checked.value) return;
    var btn = form.querySelector('[data-pdp-add]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }
    try { if (window.ttq) ttq.track('AddToCart', { content_type: 'product', currency: 'EUR' }); } catch (e) {}
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: checked.value, quantity: 1 })
    }).then(function () { window.location.href = '/checkout'; })
      .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } window.location.href = '/cart'; });
  }
  form.addEventListener('submit', function (ev) { ev.preventDefault(); addToCart(); });

  /* galería carrusel: flechas + swipe + miniaturas (soporta muchas imágenes) */
  (function () {
    var vp = document.querySelector('[data-gal-viewport]'); if (!vp) return;
    var main = document.getElementById('pdpMain');
    var thumbs = [].slice.call(document.querySelectorAll('.pdp__thumb'));
    var imgs = thumbs.map(function (t) { return t.dataset.full; });
    if (!imgs.length && main) imgs = [main.src];
    var count = document.querySelector('[data-gal-count]');
    var prevB = document.querySelector('[data-gal-prev]'), nextB = document.querySelector('[data-gal-next]');
    var i = 0;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      if (main && imgs[i]) main.src = imgs[i];
      thumbs.forEach(function (t, k) {
        t.classList.toggle('sel', k === i);
        if (k === i) { try { t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (e) {} }
      });
      if (count) count.textContent = (i + 1) + '/' + imgs.length;
    }
    if (imgs.length <= 1) { [prevB, nextB, count].forEach(function (e) { if (e) e.style.display = 'none'; }); }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    if (prevB) prevB.addEventListener('click', function () { show(i - 1); });
    if (nextB) nextB.addEventListener('click', function () { show(i + 1); });
    var x0 = null;
    vp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    vp.addEventListener('touchend', function (e) {
      if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1); x0 = null;
    }, { passive: true });
    show(0);
  })();

  /* barra fija de compra (móvil): aparece al pasar el bloque de compra */
  var addbar = document.getElementById('addbar'), pdpBuy = document.getElementById('pdp-buy');
  if (addbar && pdpBuy) {
    var onS = function () {
      var r = pdpBuy.getBoundingClientRect();
      addbar.classList.toggle('show', r.bottom < 80);
    };
    window.addEventListener('scroll', onS, { passive: true });
    onS();
  }
})();
